var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoBox"},[_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"poster":require("../assets/img/videoH5.jpg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }